"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.format = void 0;
const constants_1 = require("./constants");
const sort_direction_1 = require("./sort-direction");
function format(sortParams) {
    return sortParams.map(formatParameter).join(constants_1.recordSeparator);
}
exports.format = format;
function formatParameter(sortParam) {
    return sortParam.propertyName + constants_1.unitSeparator + formatSortDirection(sortParam.direction);
}
function formatSortDirection(sortDirection) {
    return sortDirection === sort_direction_1.SortDirection.Ascending ? 'asc' : 'desc';
}
//# sourceMappingURL=format.js.map